(() => {

  let isProcessing = false;

  function moveArticlesToArticleGrid() {

    // prevent loop
    if (isProcessing) return;

    const productContainer = document.querySelector("#ProductGridContainer");
    const articleContainer = document.querySelector("#ArticleGridContainer .article-grid");
    const titleElement = document.querySelector("#ArticleGridContainer .search-section-title");

    if (!productContainer || !articleContainer || !titleElement) return;

    const articleItems = productContainer.querySelectorAll("[data-article-block]");

    // nothing to move → stop
    if (articleItems.length === 0) return;

    isProcessing = true;

    articleItems.forEach(item => {
      articleContainer.appendChild(item);
    });



      const articles = document.querySelectorAll(".product-grid__item.article-grid-item");
      const keyword = new URLSearchParams(window.location.search).get('q');

      console.log("Search keyword:", keyword);
      console.log("Articles length:", articles.length);

      titleElement.textContent =
        `There Are ${articles.length} Article${articles.length !== 1 ? 's' : ''} for "${keyword}"`;

      isProcessing = false;



  }

  document.addEventListener("DOMContentLoaded", moveArticlesToArticleGrid);

  document.addEventListener("shopify:section:load", moveArticlesToArticleGrid);

  const observer = new MutationObserver(() => {
    moveArticlesToArticleGrid();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

})();